import type { SystemStyleObject } from '@chakra-ui/react';

export const authLayoutCss: SystemStyleObject = {
  '&': {
    position: 'relative',
    minHeight: '100dvh',
    width: 'full',
    alignItems: 'center',
    justifyContent: 'center',
    paddingY: 10,
    paddingX: 4,
    bgGradient: 'to-b',
    gradientFrom: 'bg.subtle',
    gradientTo: 'bg',
  },

  '& .panel': {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    width: 'full',
    maxWidth: 'sm',
    padding: { base: 6, sm: 8 },
    bg: 'bg.panel',
    borderWidth: '1px',
    borderColor: 'border',
    borderRadius: 'xl',
    boxShadow: 'lg',
  },

  '& .brand': {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },

  '& .app-name': {
    fontSize: 'sm',
    color: 'fg.muted',
  },
};
